/* eslint-disable no-unused-vars */
import React, { useEffect, useState, useRef } from 'react';
import { Row, Col, Upload, Button, DatePicker, message, Select } from 'antd';
import { IdcardOutlined, UploadOutlined } from '@ant-design/icons';
import { useForm, Controller } from 'react-hook-form';
// import { useCookies } from "react-cookie";
import { useHistory, useLocation } from 'react-router-dom';
import moment from 'moment';
import YFinput from '../elements/YFInput';
// import YFTextArea from "../elements/YFTextArea";
import { Button as MuiButton } from '@material-ui/core';
// import YFSelect from "../elements/YFSelect";
import { countries } from '../../utils/countries';
import { createLicese, updateLicese } from '../../api';
import useApplicationSession from '../../session/UserSession';
import road from '../../assets/images/road.svg';
import car from '../../assets/images/car.svg';
import { Affix } from 'antd';
import { SUBSCRIPTION_INFO, SUBSCRIPTION_EMPLOYEE } from '../../route/AppRouter';
const { Option } = Select;

const LicenseForm = ({ value }) => {
    const { control, register, handleSubmit, setValue, setError, errors } = useForm();
    const history = useHistory();
    const location = useLocation();
    // eslint-disable-next-line no-unused-vars
    const [frontImage, setFrontImage] = useState([]);
    const [backImage, setBackImage] = useState([]);
    const [status, setStatus] = useState(true);
    const inputRef = useRef();
    const token = useApplicationSession();
    const onSubmit = (data) => {
        message.loading('Loading ...');
        makeFormData(data);
    };

    const makeFormData = (data) => {
        const license_form_data = new FormData();
        license_form_data.append('number', data.number !== undefined && data.number);
        license_form_data.append('issuing_country', data.issuing_country !== undefined && data.issuing_country);
        license_form_data.append(
            'expiry_date',
            data.expiry_date !== undefined && data.expiry_date?.format('DD-MM-YYYY')
        );

        if (!isURL(data.front_image) && data.front_image.status !== 'removed') {
            license_form_data.append('front_image', data.front_image);
        }
        if (!isURL(data.back_image) && data.back_image.status !== 'removed') {
            license_form_data.append('back_image', data.back_image);
        }

        if (value) {
            license_form_data.append('_method', 'PUT');
            updateLicese({ token: token, request: license_form_data })
                .then((response) => {
                    onNext();
                })
                .catch((error) => {
                    if (error.errors) {
                        const nameArr = Object.keys(error.errors);
                        nameArr.forEach((key) => {
                            setError(key, 'notMatch', error.errors[key][0]);
                        });
                    }
                });
        } else {
            createLicese({ token: token, request: license_form_data })
                .then((response) => {
                    onNext();
                })
                .catch((error) => {
                    if (error.errors) {
                        const nameArr = Object.keys(error.errors);
                        nameArr.forEach((key) => {
                            setError(key, 'notMatch', error.errors[key][0]);
                        });
                    }
                });
        }
    };

    const isURL = (str) => {
        var pattern = new RegExp(
            '^(https?:\\/\\/)?' + // protocol
                '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
                '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
                '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
                '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
                '(\\#[-a-z\\d_]*)?$',
            'i'
        ); // fragment locator
        return !!pattern.test(str);
    };

    useEffect(() => {
        if (value !== null) {
            setStatus(false);
            const values = [];
            const keys = Object.keys(value);
            keys.forEach((key) => {
                if (key === 'expiry_date') {
                    values.push({
                        [key]: value[key] === '' ? '' : moment(value[key], 'DD-MM-YYYY'),
                    });
                } else {
                    values.push({ [key]: value[key] });
                }
            });
            // values.push({previous_length_of_employement: "2"})
            setValue(values);
        } else {
            // for new user
        }
    }, [setValue, value, setStatus]);

    const forntImageProps = {
        listType: 'picture',
        onRemove: (file) => {},
        beforeUpload: (file) => {
            return false;
        },
        frontImage,
    };
    const backImageProps = {
        listType: 'picture',
        onRemove: (file) => {},
        beforeUpload: (file) => {
            return false;
        },
        backImage,
    };

    const onNext = () => {
        history.push({
            pathname: `${SUBSCRIPTION_EMPLOYEE}`,
            search: location.search,
        });
    };

    const onBack = () => {
        history.push({
            pathname: `${SUBSCRIPTION_INFO}`,
            search: location.search,
        });
    };

    return (
        <div className="formStatus">
            <form onSubmit={handleSubmit(onSubmit)} className="payment-information-form ">
                {/* -------- License section -------- */}
                <div className="payment-information-label-container">
                    <IdcardOutlined className="personal-information-icon" style={{ fontSize: 20, padding: 10 }} />
                    <h4 className="payment-information-label">License</h4>
                </div>
                <section>
                    <Row className="horizontal-container">
                        <Col
                            xs={{ span: 24 }}
                            sm={{ span: 24 }}
                            md={{ span: 6 }}
                            lg={{ span: 12 }}
                            xl={{ span: 8 }}
                            xxl={{ span: 12 }}
                            className="horizontal-container-element"
                        >
                            <YFinput
                                name="number"
                                type="text"
                                label="License Number"
                                placeholder="Enter License Number"
                                register={register({ required: true })}
                            />
                            <div className="form-error">
                                {errors.number && (
                                    <span className="formFieldError"> Please enter your licence number. </span>
                                )}
                            </div>
                        </Col>
                        <Col
                            xs={{ span: 24 }}
                            sm={{ span: 24 }}
                            md={{ span: 24 }}
                            lg={{ span: 6 }}
                            xl={{ span: 8 }}
                            xxl={{ span: 12 }}
                            className="horizontal-container-element"
                        >
                            <label>Issuing Country</label>
                            <Controller
                                name="issuing_country"
                                as={
                                    <Select
                                        showSearch
                                        className="yf-select"
                                        style={{ width: '100%' }}
                                        placeholder="Select Country"
                                        ref={inputRef}
                                        optionFilterProp="children"
                                        filterOption={(input, option) =>
                                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                        }
                                    >
                                        {countries.map((item) => {
                                            return (
                                                <Option value={item.value} key={item.id}>
                                                    {item.label}
                                                </Option>
                                            );
                                        })}
                                    </Select>
                                }
                                onChange={([selected]) => {
                                    // setSateOfCountry(getStateOfCountry(selected));
                                    return selected;
                                }}
                                rules={{ required: true }}
                                control={control}
                            />
                            <div className="form-error">
                                {errors.issuing_country && (
                                    <span className="formFieldError"> Please select your issuing country. </span>
                                )}
                                {/* (<Alert type="error" message="Issuing is required!" />) */}
                            </div>
                        </Col>

                        <Col
                            xs={{ span: 24 }}
                            sm={{ span: 24 }}
                            md={{ span: 12 }}
                            lg={{ span: 12 }}
                            xl={{ span: 8 }}
                            xxl={{ span: 12 }}
                            className="horizontal-container-element"
                        >
                            <label>Expiry Date</label>
                            <Controller
                                as={<DatePicker name="expiry_date" ref={inputRef} format={'DD-MM-YYYY'} />}
                                name="expiry_date"
                                control={control}
                                rules={{ required: true }}
                                onChange={([date]) => {
                                    return date;
                                }}
                            />
                            {errors.expiry_date && (
                                <span className="formFieldError">
                                    {errors.expiry_date.message
                                        ? errors.expiry_date.message
                                        : 'Please select your expiry date'}
                                </span>
                            )}
                            {/* (<Alert type="error" message="Expiry date is required." />) */}
                        </Col>
                    </Row>
                    <Row className="horizontal-container">
                        <Col
                            xs={{ span: 24 }}
                            sm={{ span: 24 }}
                            md={{ span: 24 }}
                            lg={{ span: 4 }}
                            xl={{ span: 4 }}
                            xxl={{ span: 4 }}
                            className="horizontal-container-element"
                        >
                            <label>License Image</label>
                        </Col>
                        <Col
                            xs={{ span: 24 }}
                            sm={{ span: 24 }}
                            md={{ span: 24 }}
                            lg={{ span: 10 }}
                            xl={{ span: 10 }}
                            xxl={{ span: 10 }}
                            className="horizontal-container-element"
                        >
                            <Controller
                                name="front_image"
                                as={
                                    <Upload {...forntImageProps} accept="image/*" multiple={false}>
                                        <Button>
                                            <UploadOutlined /> Upload front image
                                        </Button>
                                    </Upload>
                                }
                                control={control}
                                onChange={([data]) => {
                                    return data.file;
                                }}
                                rules={{ required: status }}
                            />

                            {errors.front_image && (
                                <span className="formFieldError">
                                    {errors.front_image.message
                                        ? errors.front_image.message
                                        : 'Please upload your front image.'}
                                </span>
                            )}
                            <br />
                            {value?.front_image && (
                                <div className="licenseImageContainer">
                                    <img className="licensePreviewImage" src={value.front_image} alt="License" />
                                </div>
                            )}
                        </Col>

                        {/* back image */}
                        <Col
                            xs={{ span: 24 }}
                            sm={{ span: 24 }}
                            md={{ span: 24 }}
                            lg={{ span: 10 }}
                            xl={{ span: 10 }}
                            xxl={{ span: 10 }}
                            className="horizontal-container-element"
                        >
                            <Controller
                                name="back_image"
                                as={
                                    <Upload
                                        style={{ width: '100%' }}
                                        {...backImageProps}
                                        accept="image/*"
                                        multiple={false}
                                    >
                                        <Button>
                                            <UploadOutlined /> Upload back image
                                        </Button>
                                    </Upload>
                                }
                                control={control}
                                onChange={([data]) => {
                                    return data.file;
                                }}
                                rules={{ required: status }}
                            />
                            {errors.back_image && (
                                <span className="formFieldError">
                                    {errors.back_image.message
                                        ? errors.back_image.message
                                        : 'Please upload your back image.'}
                                </span>
                            )}
                            <br />
                            {value?.back_image && (
                                <div className="licenseImageContainer">
                                    <img className="licensePreviewImage" src={value.back_image} alt="License" />
                                </div>
                            )}
                        </Col>
                    </Row>
                </section>
                {/* -------- License section end -------- */}
                {/* -------- Button section -------- */}
                <div className="subscriptionContentContainerSteps">
                    <MuiButton className="secondary-btn profilePrev" onClick={() => onBack()}>
                        back
                    </MuiButton>
                    <MuiButton className="secondary-btn profileNext" type="submit">
                        next
                    </MuiButton>
                </div>
            </form>

            <Affix offsetBottom={0}>
                <div className="formStepper">
                    <img src={car} alt="Car" className="formStepperCar step2" />
                    <img src={road} alt="Road" className="formStepperRoad" />
                </div>
            </Affix>
        </div>
    );
};

export default LicenseForm;
